<div style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); z-index: 9999;">
  
    <img src="https://www.universal-assistance.com/br/wp-content/uploads/sites/4/2026/04/paso2-br-2026-mar-pop-up.png" 
    (click)="fecharDialog()"
    style="
           max-width: 600px;
           max-height: 800px;
           width: auto;
           height: auto;
           box-shadow: 0 4px 12px rgba(0,0,0,0.2);
           border-radius: 12px;
           display: block;
           cursor: pointer;
         "
     />

  <button (click)="fecharDialog()" 
  style="
         position: absolute;
         top: 10px;
         right: 10px;
         background: rgba(255, 255, 255, 0.9);
         border: none;
         border-radius: 50%;
         width: 35px;
         height: 35px;
         cursor: pointer;
         font-size: 20px;
         font-weight: bold;
         color: #333;
         display: flex;
         align-items: center;
         justify-content: center;
         box-shadow: 0 2px 8px rgba(0,0,0,0.2);
         z-index: 10000;
       "
  >×</button>
</div>